import FormGroup from '@/ui-kit/components/form/entities/FormGroup';
import FormControl from '@/ui-kit/components/form/entities/FormControl';
import {
  emailFormValidator,
  requiredFormValidator,
} from '@/ui-kit/components/form/validators';
import { FormControlValidationStrategy } from '@/ui-kit/components/form/entities/enums';
import { SoldDataShareFormControlName } from '../enums';
import { SOLD_DATA_SHARE_FORM_DEFAULT_VALUE } from '../constants';

export const nameControl = new FormControl(
  SOLD_DATA_SHARE_FORM_DEFAULT_VALUE[SoldDataShareFormControlName.Name],
  [requiredFormValidator],
);

export const emailControl = new FormControl(
  SOLD_DATA_SHARE_FORM_DEFAULT_VALUE[SoldDataShareFormControlName.Email],
  [requiredFormValidator, emailFormValidator],
);

export const soldDataShareFormGroup = new FormGroup(
  {
    [SoldDataShareFormControlName.Name]: nameControl,
    [SoldDataShareFormControlName.Email]: emailControl,
  },
  [FormControlValidationStrategy.Change, FormControlValidationStrategy.Blur],
);
